import { useState, useEffect } from "react";
import api from "../../services/api";

export default function DoletasManualForm({ onCreated, onClose }) {
  var _userId = useState("");
  var userId = _userId[0];
  var setUserId = _userId[1];
  var _amount = useState("");
  var amount = _amount[0];
  var setAmount = _amount[1];
  var _desc = useState("");
  var desc = _desc[0];
  var setDesc = _desc[1];
  var _users = useState([]);
  var users = _users[0];
  var setUsers = _users[1];

  useEffect(function () {
    async function load() {
      try {
        var res = await api.get("/clients?limit=500");
        var brokers = await api.get("/users?limit=500");
        var all = [];
        var clients = res.data.clients || [];
        for (var i = 0; i < clients.length; i++) {
          all.push({ id: clients[i].id, name: clients[i].name + " (Cliente)" });
        }
        var bUsers = brokers.data.users || [];
        for (var j = 0; j < bUsers.length; j++) {
          if (bUsers[j].role === "broker") {
            all.push({ id: bUsers[j].id, name: bUsers[j].name + " (Vendedor)" });
          }
        }
        setUsers(all);
      } catch (err) {
        console.error(err);
      }
    }
    load();
  }, []);

  async function handleCreate() {
    if (!userId || !amount) { alert("Preencha usuario e quantidade"); return; }
    try {
      await api.post("/doletas/transactions/manual", {
        user_id: userId, amount: parseFloat(amount),
        description: desc || "Ajuste manual",
      });
      if (onCreated) onCreated();
      if (onClose) onClose();
    } catch (err) {
      alert("Erro: " + (err.response?.data?.detail || err.message));
    }
  }

  var options = [];
  for (var k = 0; k < users.length; k++) {
    options.push(<option key={users[k].id} value={users[k].id}>{users[k].name}</option>);
  }

  return (
    <div className="mt-4 p-4 border border-gray-200 rounded-xl bg-gray-50" data-testid="manual-tx-form">
      <h4 className="font-medium text-[#0A2F3D] mb-3 text-sm">Nova Transacao Manual</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <select value={userId} onChange={function (e) { setUserId(e.target.value); }}
          className="px-3 py-2 border border-gray-200 rounded-lg text-sm" data-testid="manual-user-select">
          <option value="">Selecione usuario</option>
          {options}
        </select>
        <input type="number" placeholder="Doletas (+/-)" value={amount}
          onChange={function (e) { setAmount(e.target.value); }}
          className="px-3 py-2 border border-gray-200 rounded-lg text-sm" data-testid="manual-amount" />
        <input type="text" placeholder="Descricao" value={desc}
          onChange={function (e) { setDesc(e.target.value); }}
          className="px-3 py-2 border border-gray-200 rounded-lg text-sm" data-testid="manual-description" />
        <button onClick={handleCreate}
          className="px-4 py-2 bg-[#3B82F6] text-white rounded-lg text-sm font-medium hover:bg-blue-600"
          data-testid="btn-create-manual">Criar</button>
      </div>
    </div>
  );
}
